import React, { useContext, useState, useEffect } from "react";
import { closestCenter, DndContext, PointerSensor, useSensor } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { collection, query, where, onSnapshot, orderBy, limit, doc, writeBatch  } from "firebase/firestore";
import { SiSpinrilla } from "react-icons/si";
import toast from 'react-hot-toast';

import ModuleCard from '../components/ModuleCard'
import ModuleCardNew from "./ModuleCardNew";
import { FirebaseContext } from '../services/Firebase/Context'
import { AuthContext } from '../services/Session/Context'

const TrainingModulesSection = ({ id }: any) => {
  const [loading, setLoading] = useState(true)
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext) || {}
  const [items, setItems] = useState<Array<{id: string}>>([])

  const sensors = [useSensor(PointerSensor, {
    activationConstraint: {
      distance: 8,
    },
  })];

  useEffect(() => {
    if(!user || !db || !id) return
    setLoading(true)
    const q = query(
      collection(db, "training", id, "modules"),
      where("organisationId", "==", user.organisationId),
      orderBy("order"),
      limit(100))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const records: any = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setItems(records)
      setLoading(false)
    }, (e) => {
      toast.error("Oups, une erreur est survenue !")
      console.log(e.message)
      setLoading(false)
    });
    return () => unsubscribe()
  }, [db, user, id])

  const handleDragEnd = ({active, over}: any) => {
    if (!db || !id) return
    if (active.id !== over.id) {
      const batch = writeBatch(db);
      const oldIndex = items.findIndex(item => item.id === active.id)
      const newIndex = items.findIndex(item => item.id === over.id)
      const arr = arrayMove(items, oldIndex, newIndex)
      arr.forEach((el, i) => {
        batch.update(doc(db, "training", id, "modules", el.id), { order : i });
      })
      toast.promise(batch.commit(),{ 
        loading: 'Enregistrement...',
        success: "Sauvegardé !",
        error: "Une erreur est survenue !"
      })
    }
  }

  if(loading) {
    return <div className="justify-center flex flex-col items-center flex-1 h-full">
      <SiSpinrilla size={64} className="mr-2 animate-spin text-purple-600 text-center"/>
    </div>
  }

  return (
    <div className="p-5 flex flex-col items-center">
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={items.map(item => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {
            items.map(
              item => <ModuleCard 
                {...item}
                key={item.id}

              />
            )
          }
        </SortableContext>
      </DndContext>
      <ModuleCardNew pos={items.length}/>
    </div>
  );
}

export default TrainingModulesSection
